import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  ButtonGroup,
  Button,
  CustomInput,
  Row,
} from 'reactstrap';
import Languages from '../../../../../data/languages';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';

export default function MultliLanguages({ botSettings, saveIntegration }) {
  const [edit, setEdit] = useState(false);
  const [settings, setSetting] = useState(botSettings);
  const [botLanguages, setBotLanguages] = useState([]);
  const [botLanguagesList, setBotLanguagesListt] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: 'en',
    label: 'English',
  });
  useEffect(() => {
    const getLanguage = Languages.filter(
      (item) => item.code === botSettings.defaultLanguage
    );

    const filtered = Languages.filter((el) => {
      return botSettings.languages.indexOf(el.code) !== -1;
    });
    setBotLanguages(filtered);

    const languageList = Languages.map((elem) => {
      elem.checked = false;
      filtered.forEach((lang) => {
        if (lang.code === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setBotLanguagesListt(languageList);

    if (getLanguage !== undefined) {
      let lan = { value: getLanguage[0].code, label: getLanguage[0].name };
      setSelectedLanguage(lan);
    }
  }, [botSettings]);

  const handleChange = (e) => {
    const value = e.target.checked;
    setSetting({
      ...settings,
      [e.target.name]: value,
    });
  };

  const handleSave = () => {
    setEdit(!edit);
    // console.log(settings);
    saveIntegration({ botSetting: settings });
  };

  const handleChangeSelect = (selectedOptions) => {
    setSelectedLanguage(selectedOptions);
    setSetting({
      ...settings,
      defaultLanguage: selectedOptions.value,
    });
  };

  const handleLanguageChange = (e) => {
    const values = botLanguagesList.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setBotLanguagesListt(values);
  };

  useEffect(() => {
    const langArr = botLanguagesList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);

    //console.log(langArr);

    setSetting({
      ...settings,
      languages: langArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botLanguagesList]);

  const Show = () => {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Languages:</h6>
              <Separator className="mb-3" />
              <div className="mb-1">
                <b>Enable:</b>
                {botSettings.multilingual ? 'Yes' : 'No'}
              </div>
              <div className="mb-1">
                <b>Default Language:</b> {selectedLanguage.label}
              </div>
              <div className="mb-1">
                <b>Selected Languages:</b>
                <Row>
                  {botLanguages.map((lang, msgIndex) => {
                    return (
                      <Colxx xxs="4">
                        {' '}
                        <p className="text-left">{lang.name}</p>
                      </Colxx>
                    );
                  })}
                </Row>
              </div>
              <Button
                size="xs"
                color="success"
                outline
                style={{ marginTop: '20px' }}
                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Edit
              </Button>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  };

  function Edit() {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Language</h6>
              <Separator className="mb-3" />
              <div className="mb-1">
                <b>Enable</b>
                <br />
                <CustomInput
                  id="lan"
                  type="checkbox"
                  checked={settings.multilingual}
                  name="multilingual"
                  onChange={handleChange}
                />
              </div>
              <div className="mb-1">
                <b>Choose Languages</b>
                <br />
                <Row>
                  {botLanguagesList.map((elem, index) => (
                    <Colxx xxs="4">
                      {' '}
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.code}
                        id={elem.code}
                        onChange={handleLanguageChange}
                        checked={elem.checked}
                        className="text-left"
                      >
                        {elem.name}
                      </CustomInput>
                    </Colxx>
                  ))}
                </Row>
              </div>

              <div className="mb-1">
                <b>Default Language</b>
                <br />
                <Select
                  isMulti={false}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="defaultLanguage"
                  value={selectedLanguage}
                  placeholder="Select Default Language"
                  onChange={handleChangeSelect}
                  options={
                    Languages
                      ? reactSelectOptionDiffrentPro(
                          botLanguages,
                          true,
                          'code',
                          'name',
                          ''
                        )
                      : []
                  }
                />
              </div>

              <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                <Button color="primary" size="xs" outline onClick={handleSave}>
                  Save
                </Button>
                <Button
                  size="xs"
                  color="dark"
                  outline
                  onClick={() => {
                    setEdit(!edit);
                  }}
                >
                  Cancel
                </Button>
              </ButtonGroup>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  }

  return <Card className="mb-4">{edit ? Edit() : Show()}</Card>;
}
